import { useId, type ReactNode } from 'react';

import { linkControlToError } from './link-control-to-error';

export function Field({
  label,
  required,
  error,
  hint,
  errorId,
  linkControl = true,
  children,
}: {
  label: string;
  required?: boolean;
  error?: string;
  hint?: ReactNode;
  /** Id for the error text, when the control that describes itself with it is
   *  not the direct child. */
  errorId?: string;
  /** Set false when the direct child is a wrapper, not the control. */
  linkControl?: boolean;
  children: ReactNode;
}) {
  const generatedId = useId();
  const messageId = errorId ?? generatedId;
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <span style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-ink-2)' }}>
          {label}
          {required && <span style={{ color: 'var(--nb-warn)' }}> *</span>}
        </span>
        <span style={{ flex: 1 }} />
        {hint}
      </span>
      {linkControl ? linkControlToError(children, messageId, error) : children}
      {error && (
        <span id={messageId} style={{ fontSize: 10.5, color: 'var(--nb-risk)' }}>
          {error}
        </span>
      )}
    </label>
  );
}
